.hidden {
  display: none;
}

.iframe {
  display: block;
}
